import { ModalProvider } from 'shared/ui/modal';
import { SelectTag } from 'shared/ui/select/selectTag';
import { Typography, withTypographyContainer } from 'shared/ui/typography';
import { CheckboxList } from 'shared/ui/checkbox';
import {
	OrderCheckboxFilters,
	OrderResourcesGuestsFilters,
	Status,
	statusesMap,
	useOrderFilter,
} from 'entities/orders';
import { FilterCard } from 'shared/ui/pagination';
import { MarginBottom } from './styles';
import { useAppSelector } from 'shared/lib/store';
import { selectPlacesNames } from 'entities/toolbar/places';
import { selectOrderTagsNames } from 'entities/tags';
import { selectResourcesNames } from 'entities/hallmap';
import { TNameMapValue } from 'shared/lib/pagination/types';
import { FilterManager } from 'features/filterManager';
import { depositMap } from 'entities/orders/lib/helpers/data/map';
import { useEffect, useRef } from 'react';
import { Grid } from 'shared/ui/grid';

export const OrderFilterPanel = () => {
  const Label = withTypographyContainer(Typography);

	const resourcesNames = useAppSelector(selectResourcesNames);
	const placesNames = useAppSelector(selectPlacesNames);
	const tagsNames = useAppSelector(selectOrderTagsNames);

	const {
		filters,
		resourcesOptions,
		tagsOptions,
		places,
		selectedResourcesOptions,
		selectedTagsOptions,
		selectedStatusCheckbox,
		selectedPlacesCheckbox,
		selectedConfirmedCheckbox,
    paymentProvidersMap,
    depositStatusOptions,
    selectedDepositStatusOptions,
    selectedByPassCheckbox,
    defaultPersonId,
    paymentProviderOptions,
    selectedPaymentProviderOptions,
    selectedHoldResourcesCheckbox,
    isGuestAppointment,
		changeResources,
		changeTags,
		changeParticipantsStart,
		changeParticipantsEnd,
		changeStatusCheckbox,
		changePlacesCheckbox,
		changeConfirmed,
    changeDepositStatus,
    changeByPass,
    changeIsGuestAppointment,
    changePaymentProvider,
    changeHoldResources,

		reset,
	} = useOrderFilter();

	const nameMap = useRef(new Map<string, TNameMapValue>([
		[
			'appointment__resources',
			{ name: 'Столы ', namesMap: resourcesNames },
		],
		['participants_count__gte', { name: 'Гости' }],
		['participants_count__lte', { name: 'Гости' }],
		['tags', { name: 'Теги', namesMap: tagsNames }],
		[
			'status',
			{
				name: 'Статус',
				namesMap: statusesMap,
			},
		],
		['places', { name: 'Зал', namesMap: placesNames }],
		[
			'is_confirmed',
			{
				name: 'Подтверждено',
				namesMap: new Map([
					['true', 'Да'],
					['false', 'Нет'],
				]),
			},
		],
    ['appointment__bypass', { name: 'Ручное бронирование', namesMap: new Map([['true', 'Да'],['false', 'Нет'],]) }],
    ['appointment__hold_resources', { name: 'Стол не менять', namesMap: new Map([['true', 'Да'],['false', 'Нет'],]) }],
    ['is_guest_appointment', { name: 'Без бронирования', namesMap: new Map([[defaultPersonId, 'Да']]) }],
    ['deposit__status', { name: 'Статус депозита', namesMap: depositMap }],
	]));

  useEffect(() => {
    nameMap.current.set('deposit__provider',  { name: 'Способ оплаты', namesMap: paymentProvidersMap })
  }, [paymentProvidersMap])

	const getDefaultFilters = () => {
		const status: Status[] = ['appointed', 'visit_started'];
		return { status };
	};

	return (
		<ModalProvider>
			<FilterCard reset={reset} defaultFilters={getDefaultFilters()}>
				<OrderResourcesGuestsFilters
					guestsCountStart={filters.participants_count__gte}
					guestsCountEnd={filters.participants_count__lte}
					resourcesOptions={resourcesOptions}
					selectedResourcesOptions={selectedResourcesOptions}
					changeResources={changeResources}
					changeParticipantsStart={changeParticipantsStart}
					changeParticipantsEnd={changeParticipantsEnd}
				/>

				<OrderCheckboxFilters
					places={places}
					changePlacesCheckbox={changePlacesCheckbox}
					selectedPlacesCheckbox={selectedPlacesCheckbox}
					changeStatusCheckbox={changeStatusCheckbox}
					selectedStatusCheckbox={selectedStatusCheckbox}
				/>

				<MarginBottom>
					<div>
						<Label colorVariant={'main'} isBold={true}>
							Теги бронирования
						</Label>
						<SelectTag
							options={tagsOptions}
							value={selectedTagsOptions}
							onSelect={changeTags}
							placeholder="Выберите тэги"
						/>
					</div>
				</MarginBottom>

        <MarginBottom>
          <Grid
            $columns='repeat(2, 1fr)'
            $columnGap='20px'
            $rowGap='20px'
          >
            <div>
              <Label colorVariant={'main'} isBold={true}>
                Подтверждено
              </Label>
              <CheckboxList
                checkboxes={[
                  {
                    id: 'true',
                    name: 'Да',
                  },
                  {
                    id: 'false',
                    name: 'Нет',
                  },
                ]}
                flexSetting={{ direction: 'row', gap: '10px' }}
                changeCheckbox={changeConfirmed}
                defaultValue={selectedConfirmedCheckbox}
              />
            </div>

            <div>
              <Label colorVariant={'main'} isBold={true}>
                Ручное бронирование
              </Label>
              <CheckboxList
                checkboxes={[
                  {
                    id: 'true',
                    name: 'Да',
                  },
                  {
                    id: 'false',
                    name: 'Нет',
                  },
                ]}
                flexSetting={{ direction: 'row', gap: '10px' }}
                changeCheckbox={changeByPass}
                defaultValue={selectedByPassCheckbox}
              />
            </div>

            <div>
              <Label colorVariant={'main'} isBold={true}>
                Стол не менять
              </Label>
              <CheckboxList
                checkboxes={[
                  {
                    id: 'true',
                    name: 'Да',
                  },
                  {
                    id: 'false',
                    name: 'Нет',
                  },
                ]}
                flexSetting={{ direction: 'row', gap: '10px' }}
                changeCheckbox={changeHoldResources}
                defaultValue={selectedHoldResourcesCheckbox}
              />
            </div>

            <div>
              <Label colorVariant={'main'} isBold={true}>
                Без бронирования
              </Label>
              <CheckboxList
                checkboxes={[
                  {
                    id: 'true',
                    name: 'Да',
                  },
                  {
                    id: 'false',
                    name: 'Нет',
                  },
                ]}
                flexSetting={{ direction: 'row', gap: '10px' }}
                changeCheckbox={changeIsGuestAppointment}
                defaultValue={isGuestAppointment}
              />
            </div>
          </Grid>
        </MarginBottom>

				<MarginBottom>
					<div>
						<Label colorVariant={'main'} isBold={true}>
              Статус депозита
						</Label>
						<SelectTag
							options={depositStatusOptions}
							value={selectedDepositStatusOptions}
							onSelect={changeDepositStatus}
							placeholder="Выберите способы"
						/>
					</div>
				</MarginBottom>

				<MarginBottom>
					<div>
						<Label colorVariant={'main'} isBold={true}>
							Способ оплаты
						</Label>
						<SelectTag
							options={paymentProviderOptions}
							value={selectedPaymentProviderOptions}
							onSelect={changePaymentProvider}
							placeholder="Выберите статусы"
						/>
					</div>
				</MarginBottom>
			</FilterCard>

			<FilterManager
				dateFilter={{
					start: 'dt_start__gte',
					end: 'dt_end__lte',
				}}
				filterTagsNames={nameMap.current}
				defaultFilters={getDefaultFilters()}
				showStat
			/>
		</ModalProvider>
	);
};
